
App.MobileAppController = Em.Controller.extend
  env: Em.inject.service('environment')
  notifier: Em.inject.service()

  organization: null
  themes: null

  skinsBinding: 'model'
  isSelectingTheme: false

  mobileSkins: Em.computed.filterBy('skins', 'platform', 'mobile')
  selectedSkins: Em.computed.filterBy('mobileSkins', 'is_selected', true)
  selectedSkinBinding:  'selectedSkins.firstObject'

  selectSkinIsLoading: false
  publishIsLoading: false

  groupOptions: (->
    skin = @get('selectedSkin')
    return unless skin
    groups = skin.get('theme.options.groups')
    options = skin.get('theme.options.settings')
    groupedOptions = groups.map (group) =>
      id: group.id
      title: group["text_#{Em.I18n.locale}"] || group.text
      options: options.filter (option) => option.group is group.id
    groupedOptions
  ).property('selectedSkin', 'selectedSkin.theme.options.settings.@each')

  updateOptionVisibility: (option, configuration, skin, context) ->
    dependsOn = option.depends_on
    return unless dependsOn

    isHidden = if option.strict_depends then Object.keys(dependsOn).some (key) ->
      selectedValue = configuration[key]?.value
      currentValue = dependsOn[key]
      selectedValue != currentValue
    else false

    Ember.set(option, 'is_hidden', isHidden)

    # if isHidden
      # @resetOptionToDefault(option, configuration, skin, context)

  selectSkin: (skin) ->
    @get('skins').forEach (skin) -> skin.set('is_selected', false)
    skin.set('is_selected', true)
    skin.select()

  actions:
    goBackToSettings: ->
      @set('isSelectingTheme', false)
      false

    refreshPreview: ->
      @get('mobileAppPreviewComponent').send('applyConfig')

    startThemeSelection: ->
      @set('isSelectingTheme', true)


    publishCurrentSkin: ->
      skin = @get('selectedSkin')
      return unless skin

      @set('publishIsLoading', true)
      skin.publish().finally =>
        @get('notifier').pushNotification
          type: 'success'
          title: Em.I18n.t('themes.notifications.publish.title')
          message: Em.I18n.t('themes.notifications.publish.message', {theme:skin.get('theme.title')})
          duration: 5000
        @set 'publishIsLoading', false

    resetCurrentSkin: ->
      defer = Em.RSVP.defer()
      skin = @get('selectedSkin')
      return unless skin
      if confirm(Em.I18n.t('themes.confirms.reset'))
        @set('publishIsLoading', true)
        defer.resolve()
        Em.run.next =>
          skin.reset().finally =>
            @get('notifier').pushNotification
              type: 'success'
              title: Em.I18n.t('themes.notifications.reset.title')
              message: Em.I18n.t('themes.notifications.reset.message', {theme:skin.get('theme.title')})
              duration: 5000
            @set 'publishIsLoading', false
      else defer.reject()
      defer.promise

    selectSkin: (skin) ->
      return if @get('selectSkinIsLoading')

      @set('selectSkinIsLoading', true)
      @selectSkin(skin).finally =>
        @set 'selectSkinIsLoading', false
        @set('isSelectingTheme', false)

    gotoAddressChange: ->
      @transitionToRoute('settings.organization.host')
      false

    toggleGroupVisibility: (id) ->
      target = Em.$("[data-group-id='#{id}']")
      return unless target
      target.parent().toggleClass('hidden')
      target.toggle(200)
      if !target.parent().hasClass('hidden')
        Em.run.later =>
          target.get(0).scrollIntoView
            behavior: "smooth"
            block: "center"
        , 200

